<div class="row mhide">
 <div class="col-md-12 nopad">
 <div class="card content ">
 <div class=" Head ">
 <div class="card-header d-flex justify-content-between align-items-center">
 <h3>Update Company details</h3>
 <div class="dropdown">
 <a (click)="appservice.back()" style="font-size: 20px;font-weight: 900;cursor: pointer;color:black">
 <b>X</b>
 </a>
 </div>
 </div>
 </div>

 <div class="content_body">
 <div class="row" style="background-color: white;">
 <div class="col-md-8 col-md-offset-2">
 <form #addForm="ngForm" (ngSubmit)="updateCompany(addForm)">
 <div class="row">
 <div class="col-sm-12">
 <div class="form-group">
 <label>Company Name <span class="text-danger">*</span></label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Name" name="CM_Name" #CM_Name="ngModel">
 </div>
 </div>
 </div>
 <div class="row">
 <div class="col-sm-12">
 <div class="form-group">
 <label>Address</label>
 <input class="form-control " type="text" [(ngModel)]="uptC.CM_Address1" name="CM_Address1" #CM_Address1="ngModel">
 </div>
 </div>
 <div class="col-sm-12">
 <div class="form-group">
 <input class="form-control " type="text" [(ngModel)]="uptC.CM_Address2" name="CM_Address2" #CM_Address2="ngModel">
 </div>
 </div>
 <div class="col-sm-12">
 <div class="form-group">
 <input class="form-control " type="text" [(ngModel)]="uptC.CM_Address3" name="CM_Address3" #CM_Address3="ngModel">
 </div>
 </div>
 <div class="col-sm-6 col-md-6 ">
 <div class="form-group">
 <label>State</label>
 <select class="form-control select" [(ngModel)]="uptC.CM_State" name="CM_State" #CM_State="ngModel">
 <option value="California">Tamil Nadu</option>
 <option value="Alaska">Karnataka</option>
 <option value="Alabama">Kerala</option>
 </select>
 </div>
 </div>
 <div class="col-sm-6 col-md-6 ">
 <div class="form-group">
 <label>Pin Code</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Address5" name="CM_Address5" #CM_Address5="ngModel">
 </div>
 </div>
 </div>
 <div class="row">
 <div class="col-sm-6">
 <div class="form-group">
 <label>GST No</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_GST_No" name="CM_GST_No" #CM_GST_No="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Email</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Email_ID" name="CM_Email_ID" #CM_Email_ID="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Phone Number</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Phone_off" name="CM_Phone_off" #CM_Phone_off="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Mobile No</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Phone_Res" name="CM_Phone_Res" #CM_Phone_Res="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Bank Name</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Bank_Name" name="CM_Bank_Name" #CM_Bank_Name="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Acc Name</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Acc_Name" name="CM_Acc_Name" #CM_Acc_Name="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Account No</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Acc_Number" name="CM_Acc_Number" #CM_Acc_Number="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>IFSC Code</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_IFSC" name="CM_IFSC" #CM_IFSC="ngModel">
 </div>
 </div>
 <div class="col-sm-6">
 <div class="form-group">
 <label>Branch</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Branch" name="CM_Branch" #CM_Branch="ngModel">
 </div>
 </div>
 <div class="col-sm-12">
 <div class="form-group">
 <label>Sales Footer</label>
 <input class="form-control" type="text" [(ngModel)]="uptC.CM_Sales_Footer" name="CM_Sales_Footer" #CM_Sales_Footer="ngModel">
 </div>
 </div>
 <div class="col-sm-12">
 <div class="form-group">
 <label>Sales Term</label>
 <textarea rows="4" class="form-control" [(ngModel)]="uptC.CM_Sales_Term" name="CM_Sales_Term" #CM_Sales_Term="ngModel"></textarea>
 </div>
 </div>
 </div>
 <div class="row">
 <div class="col-sm-12">
 <div *ngIf="uptCompany" class="alert alert-info m-t-10" style="text-align: center;">
 <strong class="text-center">Saved Successfully</strong>
 </div>
 </div>
 </div>
 <div class="row">
 <div class="col-sm-12 text-center m-t-20">
 <button class="btn btn-info rounded-pil" [disabled]="btndisable" type="submit">
 <span *ngIf="btndisable==true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
 <i *ngIf="btndisable==false" class='bx bx-paper-plane'></i> Save &amp; update
 </button>
 </div>
 </div>
 </form>
 </div>

 <div class="col-md-4">
 <img [src]="get_Company_image()" />
 <div class="form-group ">
 <label>Upload Company Logo</label>
 <p-fileUpload name="myfile[]" url="{{server}}" (onUpload)="onUpload($event)" multiple="multiple" maxFileSize="1000000">
 <ng-template pTemplate="content">
 <ul *ngIf="uploadedFiles.length">
 <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
 </ul>
 </ng-template>
 </p-fileUpload>
 </div>
 <img [src]="get_Company_sign()" />
 <div class="form-group ">
 <label>Upload Company signature</label>
 <p-fileUpload name="myfile[]" url="{{server_sign}}" (onUpload)="onUpload($event)" multiple="multiple" maxFileSize="1000000">
 <ng-template pTemplate="content">
 <ul *ngIf="uploadedFiles.length">
 <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
 </ul>
 </ng-template>
 </p-fileUpload>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
</div>

<<!-- Modernized Mobile View for Company Setting -->
<div class="row mshow">
 <!-- Sticky Header -->
 <div class="sticky-header">
 <li (click)="appservice.back()" class="bx bx-left-arrow-alt back-btn"></li>
 <label class="header-title-mobile">Company Setting</label>
 </div>

 <div class="col-md-12 nopad mobile-body-report">
 <div class="p-3">
 <form #addFormMob="ngForm" (ngSubmit)="updateCompany(addFormMob)">
 <!-- Basic Info Card -->
 <div class="report-card-mobile shadow-sm mb-4" style="padding-top: 0;">
 <div class="card-head d-flex align-items-center mb-3" style="background: #f8fafc; margin: 0 -15px 15px -15px; padding: 10px 15px; border-radius: 12px 12px 0 0; border-bottom: 1px solid #e2e8f0;">
 <i class='bx bx-info-circle mr-2' style="color: #1e3c72; font-size: 18px;"></i>
 <span style="color: #1e3c72; font-weight: 800; font-size: 14px;">BASIC INFORMATION</span>
 </div>
 <div class="px-2">
 <div class="form-group mb-3">
 <label class="small-label">Company Name <span class="text-danger">*</span></label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Name" name="CM_Name_Mob" required>
 </div>
 <div class="form-group mb-3">
 <label class="small-label">GST No</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_GST_No" name="CM_GST_No_Mob">
 </div>
 <div class="form-group mb-0">
 <label class="small-label">Email Address</label>
 <div class="input-with-icon">
 <i class='bx bx-envelope text-muted'></i>
 <input class="form-control modern-input" type="email" [(ngModel)]="uptC.CM_Email_ID" name="CM_Email_ID_Mob">
 </div>
 </div>
 </div>
 </div>

 <!-- Contact & Address Card -->
 <div class="report-card-mobile shadow-sm mb-4" style="padding-top: 0;">
 <div class="card-head d-flex align-items-center mb-3" style="background: #f8fafc; margin: 0 -15px 15px -15px; padding: 10px 15px; border-radius: 12px 12px 0 0; border-bottom: 1px solid #e2e8f0;">
 <i class='bx bx-map-pin mr-2' style="color: #1e3c72; font-size: 18px;"></i>
 <span style="color: #1e3c72; font-weight: 800; font-size: 14px;">CONTACT & ADDRESS</span>
 </div>
 <div class="px-2">
 <div class="form-group mb-3">
 <label class="small-label">Primary Address</label>
 <input class="form-control modern-input mb-2" type="text" [(ngModel)]="uptC.CM_Address1" name="CM_Address1_Mob" placeholder="Line 1">
 <input class="form-control modern-input mb-2" type="text" [(ngModel)]="uptC.CM_Address2" name="CM_Address2_Mob" placeholder="Line 2">
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Address3" name="CM_Address3_Mob" placeholder="Line 3">
 </div>
 <div class="row">
 <div class="col-7">
 <div class="form-group mb-3">
 <label class="small-label">State</label>
 <select class="form-control modern-input" [(ngModel)]="uptC.CM_State" name="CM_State_Mob">
 <option value="California">Tamil Nadu</option>
 <option value="Alaska">Karnataka</option>
 <option value="Alabama">Kerala</option>
 </select>
 </div>
 </div>
 <div class="col-5">
 <div class="form-group mb-3">
 <label class="small-label">PIN Code</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Address5" name="CM_Address5_Mob">
 </div>
 </div>
 </div>
 <div class="row">
 <div class="col-6">
 <div class="form-group mb-0">
 <label class="small-label">Office Phone</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Phone_off" name="CM_Phone_off_Mob">
 </div>
 </div>
 <div class="col-6">
 <div class="form-group mb-0">
 <label class="small-label">Mobile No</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Phone_Res" name="CM_Phone_Res_Mob">
 </div>
 </div>
 </div>
 </div>
 </div>

 <!-- Bank Details Card -->
 <div class="report-card-mobile shadow-sm mb-4" style="padding-top: 0;">
 <div class="card-head d-flex align-items-center mb-3" style="background: #f8fafc; margin: 0 -15px 15px -15px; padding: 10px 15px; border-radius: 12px 12px 0 0; border-bottom: 1px solid #e2e8f0;">
 <i class='bx bx-building-house mr-2' style="color: #1e3c72; font-size: 18px;"></i>
 <span style="color: #1e3c72; font-weight: 800; font-size: 14px;">BANK DETAILS</span>
 </div>
 <div class="px-2">
 <div class="form-group mb-3">
 <label class="small-label">Bank Name</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Bank_Name" name="CM_Bank_Name_Mob">
 </div>
 <div class="form-group mb-3">
 <label class="small-label">Account Holder Name</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Acc_Name" name="CM_Acc_Name_Mob">
 </div>
 <div class="form-group mb-3">
 <label class="small-label">Account Number</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Acc_Number" name="CM_Acc_Number_Mob">
 </div>
 <div class="row">
 <div class="col-6">
 <div class="form-group mb-0">
 <label class="small-label">IFSC Code</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_IFSC" name="CM_IFSC_Mob">
 </div>
 </div>
 <div class="col-6">
 <div class="form-group mb-0">
 <label class="small-label">Branch</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Branch" name="CM_Branch_Mob">
 </div>
 </div>
 </div>
 </div>
 </div>

 <!-- Branding & Customization Card -->
 <div class="report-card-mobile shadow-sm mb-4" style="padding-top: 0;">
 <div class="card-head d-flex align-items-center mb-3" style="background: #f8fafc; margin: 0 -15px 15px -15px; padding: 10px 15px; border-radius: 12px 12px 0 0; border-bottom: 1px solid #e2e8f0;">
 <i class='bx bx-brush mr-2' style="color: #1e3c72; font-size: 18px;"></i>
 <span style="color: #1e3c72; font-weight: 800; font-size: 14px;">BRANDING & MEDIA</span>
 </div>
 
 <div class="px-2">
 <div class="mb-4 text-center">
 <label class="small-label d-block text-left mb-2">Company Logo</label>
 <div class="position-relative d-inline-block mb-2" style="background: #f1f5f9; border-radius: 12px; padding: 10px;">
 <img [src]="get_Company_image()" class="img-fluid" style="max-height: 100px; border-radius: 8px;">
 </div>
 <p-fileUpload name="myfile[]" url="{{server}}" (onUpload)="onUpload($event)" mode="basic" chooseLabel="Update Logo" chooseIcon="bx bx-camera" class="w-100"></p-fileUpload>
 </div>
 
 <div class="mb-4 text-center">
 <label class="small-label d-block text-left mb-2">Authorized Signature</label>
 <div class="position-relative d-inline-block mb-2" style="background: #f1f5f9; border-radius: 12px; padding: 10px;">
 <img [src]="get_Company_sign()" class="img-fluid" style="max-height: 60px; border-radius: 4px;">
 </div>
 <p-fileUpload name="myfile[]" url="{{server_sign}}" (onUpload)="onUpload($event)" mode="basic" chooseLabel="Update Signature" chooseIcon="bx bx-edit" class="w-100"></p-fileUpload>
 </div>
 
 <div class="form-group mb-3">
 <label class="small-label">Sales Footer Text</label>
 <input class="form-control modern-input" type="text" [(ngModel)]="uptC.CM_Sales_Footer" name="CM_Sales_Footer_Mob">
 </div>
 <div class="form-group mb-0">
 <label class="small-label">Sales Terms & Conditions</label>
 <textarea rows="3" class="form-control modern-input" [(ngModel)]="uptC.CM_Sales_Term" name="CM_Sales_Term_Mob"></textarea>
 </div>
 </div>
 </div>

 <!-- Save Button Section -->
 <div class="mb-5 pb-4">
 <button class="btn btn-primary d-flex align-items-center justify-content-center w-100 shadow-lg py-3" style="border-radius: 15px; font-weight: 800; font-size: 16px; background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); border: none;" [disabled]="btndisable" type="submit">
 <span *ngIf="btndisable==true" class="spinner-border spinner-border-sm mr-2" role="status"></span>
 <i *ngIf="!btndisable" class='bx bx-check-double mr-2' style="font-size: 20px;"></i> 
 {{ btndisable ? 'Updating...' : 'SAVE & UPDATE SETTINGS' }}
 </button>
 </div>
 </form>
 </div>
 </div>
</div>
